<template>
  <div class="main">
    <section class="panel panel-default" style="margin-bottom: 0px;" v-if="isAdmin('stay')">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="searchArea" class="panel-collapse collapse">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">日期區間</label>
                <div class="col-md-8">
                  <datepicker :format="customFormatter" :language="zh" input-class="form-control"
                              v-model="search.eventTimeBegin" name="eventTimeBegin"
                              :style="{width:'46%', display:'inline-block'}"
                              @closed="endState.disabledDates.to = search.eventTimeBegin; (search.eventTimeEnd < search.eventTimeBegin ? search.eventTimeEnd = ``: search.eventTimeEnd = search.eventTimeEnd)"/>
                  <span style="width:2%;">~</span>
                  <datepicker :format="customFormatter" :language="zh" input-class="form-control"
                              v-model="search.eventTimeEnd" name="eventTimeEnd"
                              :style="{width:'46%', display:'inline-block'}" :disabled-dates="endState.disabledDates"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">地點</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.occurLoca" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">學號</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.account" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">卡號</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.cardNo" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">刷卡人員</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.studentName" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">刷卡宿舍</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.bedFloodRoom" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">實際編碼</label>
                <div class="col-md-8">
                  <input type="text" v-model="search.remark" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-offset-4 col-md-4 ">
              <div class="col-md-offset-2 col-md-4">
                <button type="button" class="btn btn-default btn-block" @click="onClearSearch">清除</button>
              </div>
              <div class="col-md-4">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">門禁刷卡記錄</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
              <tr>
                <th class="text-center" style="width:15%;">刷卡時間</th>
                <th class="text-center" style="width:10%;">事件</th>
                <th class="text-center" style="width:15%;">刷卡地點</th>
                <th class="text-center" style="width:10%;">卡號</th>
                <th class="text-center" style="width:10%;">學號</th>
                <th class="text-center" style="width:13%;">刷卡人員</th>
                <th class="text-center" style="width:17%;">刷卡宿舍</th>
                <th class="text-center" style="width:10%;">實際編碼</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in menjinList" :key="index">
                <td class="text-center" data-title="刷卡時間">{{ customFormatter(item.eventTime, "YYYY/MM/DD HH:mm:ss") }}
                </td>
                <td class="text-center" data-title="事件">{{ item.eventCase }}</td>
                <td class="text-center" data-title="刷卡地點">{{ item.occurLoca }}</td>
                <td class="text-center" data-title="卡號">{{ item.cardNo }}</td>
                <td class="text-center" data-title="學號">{{ item.account }}</td>
                <td class="text-center" data-title="刷卡人員">{{ item.studentName }}</td>
                <td class="text-center" data-title="刷卡宿舍">{{ item.bedFloodRoom }}</td>
                <td class="text-center" data-title="實際編碼">{{ item.remark }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menjinList: [],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      search: {
        account: "",
        occurLoca: "",
        eventTimeBegin: "",
        eventTimeEnd: "",
        cardNo: "",
        studentName: "",
        bedFloodRoom: "",
        remark: ""
      },
      endState: {
        disabledDates: {
          to: null
        }
      },
    }
  },
  mounted() {
    this.gridInit();
  },
  methods: {
    gridInit() {
      const CallApi = async () => {
        return await this.$axios.post("/api/Menjin/", JSON.stringify({
          page: this.page,
          pageSize: this.pageSize,
          model: this.search
        }));
      }
      Promise.all([CallApi()]).then(a => {
        const resp = a[0].data;
        this.menjinList = resp.rows;
        this.page = resp.page;
        this.totalPage = resp.total;
      });
    },
    updateGrid(page) {
      //更新Grid 必需
      this.page = page;
      this.gridInit();
    },
    onClearSearch() {
      this.endState.disabledDates.to = null;
      this.search = {
        account: "",
        occurLoca: "",
        eventTimeBegin: "",
        eventTimeEnd: "",
        cardNo: "",
        studentName: "",
        bedFloodRoom: "",
      }
    }
  }
}
</script>
